<template>
    <div>
      <ul class="gongsixinxi fl">
        <h3>公司信息</h3>
        <li><span>企业名称：</span>{{data.u__customerName}}</li>
        <li><span>统一社会信用代码：{{data.i__socialIdentityCode}}</span></li>
        <li><span>营业期限：{{data.i__bizlicValidity1}}-{{data.i__bizlicValidity2  }}</span></li>
        <!-- <li><span>注册资本：{{data.i__registeredCapital}}</span></li> -->
        <li><span>单位所在地：{{data.i__province}}&nbsp;{{data.i__city}}</span></li>
        <li><span>住所：{{data.i__address}}</span></li>
        <li><span>所属行业：{{data.i__industry}}</span></li>
      </ul>
      <ul class="farenxinxi fl">
        <h3>法人信息</h3>
        <li><span>法人姓名：{{data.i__bizrep}}</span></li>
        <li><span>证件号码：{{data.i__bizrepIC}}</span></li>
        <li><span>证件有效期：{{data.i__bizrepICValidity1}}-{{data.i__bizrepICValidity2}}</span></li>
        <li><span>手机：{{data.i__bizrepTelNo}}</span></li>
      </ul>
      <ul class="lianxirenxinxi fl">
        <h3>联系人信息</h3>
        <li><span>姓名：{{data.i__contactPerson}}</span></li>
        <li><span>性别：{{data.i__contactSex|sex2CN }}</span></li>
        <li><span>手机：{{data.i__contactTelNo}}</span></li>
        <li><span>电话：{{data.i__contactTelNo2}}</span></li>
        <li><span>传真：{{data.i__contactFaxNo}}</span></li>
        <li><span>邮箱：{{data.i__contactEmail}}</span></li>
      </ul>
    </div>
</template>

<script>
  import sexOptions from '../../utils/sexOptions'

  export default {
    name: "CustomerSummary",
    data() {
      return {

      }
    },
    props: {
      data: {
        type: Object,
        default: ()=>{
          return {}
        }
      }
    },
    filters: {
      sex2CN: function (sex) {
        let sexItem = sexOptions.filter(item=>item.value == sex).shift()||[]
        return sexItem.label||''
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/CustomerSummary.vue